/**
 * 将当前任务名册队员的已加载轨迹导出为 KML（客户端生成，不经后端）。
 */
function esc(s) {
  return String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function pointCoords(p) {
  if (!p) return null;
  const lon = Number(p.longitude ?? p.lon ?? p.lng ?? p[0]);
  const lat = Number(p.latitude ?? p.lat ?? p[1]);
  if (!Number.isFinite(lon) || !Number.isFinite(lat)) return null;
  if (Math.abs(lon) > 180 || Math.abs(lat) > 90) return null;
  if (lon === 0 && lat === 0) return null;
  const alt = Number(p.altitude ?? p.alt ?? p[2]);
  if (Number.isFinite(alt)) return `${lon},${lat},${alt}`;
  return `${lon},${lat},0`;
}

function memberTrackPoints(trackData, name) {
  const arr = trackData && name ? trackData[name] : null;
  return Array.isArray(arr) ? arr : [];
}

/**
 * @param {{ missionName?: string, members?: object[], trackData?: object }} opts
 * @returns {{ ok: boolean, count: number, filename?: string, blob?: Blob, message?: string }}
 */
export function buildMissionMembersKml({ missionName = '任务', members = [], trackData = {} } = {}) {
  const placemarks = [];
  let lineCount = 0;
  (members || []).forEach((m) => {
    const name = m?.name || m?.device_unique_id || '队员';
    const pts = memberTrackPoints(trackData, m?.name)
      .map(pointCoords)
      .filter(Boolean);
    if (pts.length < 2) return;
    lineCount += 1;
    placemarks.push(
      `<Placemark>\n`
      + `  <name>${esc(name)}</name>\n`
      + `  <Style><LineStyle><color>ffc87800</color><width>3</width></LineStyle></Style>\n`
      + `  <LineString><tessellate>1</tessellate><coordinates>\n`
      + `    ${pts.join(' ')}\n`
      + `  </coordinates></LineString>\n`
      + `</Placemark>`
    );
  });

  if (!placemarks.length) {
    return {
      ok: false,
      count: 0,
      message: '该任务暂无已加载且可导出的队员轨迹（请先获取/绘制轨迹）'
    };
  }

  const kml = `<?xml version="1.0" encoding="UTF-8"?>\n`
    + `<kml xmlns="http://www.opengis.net/kml/2.2">\n`
    + `<Document>\n`
    + `  <name>${esc(missionName)} 队员轨迹</name>\n`
    + placemarks.join('\n')
    + `\n</Document>\n</kml>\n`;

  const safe = String(missionName || 'mission').replace(/[\\/:*?"<>|]+/g, '_').slice(0, 40);
  const blob = new Blob([kml], { type: 'application/vnd.google-earth.kml+xml;charset=utf-8' });
  return {
    ok: true,
    count: lineCount,
    filename: `${safe}_tracks_${Date.now()}.kml`,
    blob
  };
}

export function downloadMissionMembersKml(opts) {
  const result = buildMissionMembersKml(opts);
  if (!result.ok) return result;
  try {
    const url = URL.createObjectURL(result.blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = result.filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
  } catch (err) {
    return { ok: false, count: 0, message: err?.message || '下载失败' };
  }
  return result;
}
